// The owner cards of the repository panel: this company's own connected GitHub accounts, as the
// server lists them (never a fixed list of somebody's organisations).
export function ownerCards(connection) {
  return ((connection && connection.owners) || [])
    .filter((o) => o && o.login)
    .map((o) => ({ value: o.login, label: o.login, use: o.use || "" }));
}

// What "Connect" sends: the token as typed, and the organisations from one comma-separated box.
export function connectPayload(token, ownersText) {
  const owners = String(ownersText || "")
    .split(",")
    .map((name) => name.trim())
    .filter(Boolean)
    .map((login) => ({ login }));
  return { token: String(token || "").trim(), owners };
}
